// @flow

const getPaintByValue = (value: string): string => {
  if (/^[1-5]$/.test(value)) {
    return `mark-${value}`;
  }
  return 'mark-default';
};

export default getPaintByValue;
